var map = {
	"./GettyImages-1061685670_crop.jpg": 551,
	"./Moringa-collecting---Mike-goldwater-Alamy.jpg": 552,
	"./a-staple-food-withstand-disaster.jpg": 553,
	"./ageing-crisis.jpg": 554,
	"./crucial-ingredient.jpg": 555,
	"./greenRev_desktop.jpg": 556,
	"./greenRev_mobile.png": 557,
	"./greenRev_tablet.png": 558,
	"./growing-new-farmers.jpg": 559,
	"./how-a-transfarmation-can-help-the-climate.jpg": 560,
	"./how-to-cut-your-foods-carbon-footprint.jpg": 561,
	"./it-never-rains.jpg": 562,
	"./seeds-of-life.jpg": 563,
	"./the-farms-being-run-from-space.jpg": 564,
	"./the-hidden-hunger-affectiong-billions.jpg": 565,
	"./the-promised-land.jpg": 566,
	"./the-race-to-improve-food-security.jpg": 567,
	"./the-robots-putting-food-on-the-table.jpg": 568,
	"./the-wasteful-fate-of-a-third-of-food.jpg": 569,
	"./urban-farming.jpg": 570,
	"./vertical_farm.jpg": 571,
	"./why-soil-is-dissappearing-from-our-farms.jpg": 572
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 550;